import { Component, OnInit, Input, ViewChild, ElementRef, Output, SimpleChanges, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-google-pay',
  templateUrl: './google-pay.component.html',
  styleUrls: ['./google-pay.component.scss']
})
export class GooglePayComponent implements OnInit {
  @Input() client;
  @Input() productInfo;
  @Input() termsAccepted: boolean = false;
  @Input() token: string;
  @Input() enabled: boolean;
  @Input() gPayId;

  @Output() sendGooglePayAuth = new EventEmitter();
  @Output() paymentError = new EventEmitter();
  @Output() displayTerms = new EventEmitter();
  @Output() googlePayInit = new EventEmitter();

  @ViewChild("googlePayContainer") googlePayContainer: ElementRef;

  googlePay: any;
  googlePayAvailable: boolean = true;
  googlePayReady: boolean = false;

  // Once true, clicks pass through to Google's own button so the
  // payment sheet opens from a real user gesture (browser requirement).
  termsWereAccepted: boolean = false;

  constructor() { }

  ngOnInit(): void {}

  ngAfterViewInit(): void {
    if (!this.enabled) {
        this.googlePayAvailable = false;
        this.googlePayInit.emit(true);
        return;
    }

    this.initializeGooglePay();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (!this.googlePayAvailable) return

    // Create new Google Pay instance with newly selected product
    if (
      changes.productInfo &&
      !changes.productInfo.firstChange &&
      changes.productInfo.currentValue?.plan != changes.productInfo.previousValue?.plan
    ) {
      this.termsWereAccepted = false;

      if (changes.productInfo.currentValue.plan)
        this.productInfo = changes.productInfo.currentValue;

      this.initializeGooglePay();
    }

    if (changes.termsAccepted) {
      this.termsWereAccepted = !!changes.termsAccepted.currentValue;
      if (this.termsWereAccepted) {
        this.openGooglePaySheet();
      }
    }
  }

  // Simulates a click on Braintree's real button (hidden behind our terms
  // overlay) from within the same synchronous gesture chain as the terms
  // checkbox change, so the native Google Pay sheet opens without requiring
  // a second physical click.
  private openGooglePaySheet() {
    const button = this.googlePayContainer?.nativeElement?.querySelector('button');
    button?.click();
  }

  initializeGooglePay() {
    // First remove any instance of google pay to start a new instance
    this.googlePay = null;
    this.googlePayReady = false;

    try {
      console.log(this.productItem);
      this.googlePay = this.client.GooglePay(this.productItem);
    } catch (e) {
      console.error(`Google Pay Initialize Error`);
      console.error(e);
      this.googlePayAvailable = false;
      this.googlePayInit.emit(true);
    } finally {
      if (!this.googlePayAvailable) return

      this.onBuildGooglePay();

    }
  }

  termsClickHandler() {
    this.displayTerms.emit("googlepay");
  }

  onBuildGooglePay() {

    this.googlePay.on('ready', (button: HTMLElement) => {
        this.googlePayContainer.nativeElement.innerHTML = '';
        this.googlePayContainer.nativeElement.appendChild(button);
        this.googlePayReady = true;
        this.googlePayInit.emit(true);
    });

    this.googlePay.on('token', (res) => {
      this.sendGooglePayAuth.emit({
        type: 'googlepay',
        token: res.id
      });
    });

    this.googlePay.on('error', (err) => {
      console.error('Google Pay error', err);
      this.paymentError.emit({
        type: 'googlepay',
        message: err
      })
    });

  }

  // Google's button opens the payment sheet immediately on click, so terms
  // must be captured on a first click via this overlay before the real
  // Google Pay button (rendered by Recurly inside #googlePayContainer)
  overlayClickHandler(e: Event) {
    e.preventDefault();
    e.stopPropagation();
    this.displayTerms.emit('googlepay');
  }

  get productItem() {
    return {
      country: 'US',
      currency: 'USD',
      total: `${this.productInfo.price}`,
      googleMerchantId: this.gPayId,
      buttonOptions: {
        buttonType: 'checkout',
        buttonColor: 'black'
      },
      braintree: {
        clientAuthorization: this.token
      }
    }
  }
}
